import { instanceV2 } from "../../api";

const campaignApi = {
    list: (branchID, params) =>
        instanceV2().get(`/branches/${branchID}/campaigns`, { params }).then((r) => r.data),
    detail: (id) =>
        instanceV2().get(`/campaigns/${id}`).then((r) => r.data),
    recipients: (id, params) =>
        instanceV2().get(`/campaigns/${id}/recipients`, { params }).then((r) => r.data),
    create: (req) =>
        instanceV2().post(`/campaigns`, req).then((r) => r.data),
    pause: (id) =>
        instanceV2().post(`/campaigns/${id}/pause`).then((r) => r.data),
    resume: (id) =>
        instanceV2().post(`/campaigns/${id}/resume`).then((r) => r.data),
    cancel: (id) =>
        instanceV2().post(`/campaigns/${id}/cancel`).then((r) => r.data),
    retryFailed: (id) =>
        instanceV2().post(`/campaigns/${id}/retry-failed`).then((r) => r.data),
    testSend: (id, phones) =>
        instanceV2().post(`/campaigns/${id}/test-send`, { phones }).then((r) => r.data),
    listTemplates: (branchID) =>
        instanceV2().get(`/branches/${branchID}/whatsapp/templates`).then((r) => r.data),
    createTemplate: (branchID, body) =>
        instanceV2().post(`/branches/${branchID}/whatsapp/templates`, body).then((r) => r.data),
    analytics: (id, window) =>
        instanceV2().get(`/campaigns/${id}/analytics`, { params: window ? { window } : {} }).then((r) => r.data),
    estimate: (body) =>
        instanceV2().post(`/campaigns/estimate`, body).then((r) => r.data),
};

export default campaignApi;
